/**
 * 画面遷移時、遷移元画面の情報をクエリに保持・復元するための共通処理
 */
import _Vue from 'vue'
import router from '@/router'

/**
 * 本体定義
 */
export default {
  install(Vue: typeof _Vue): void {
    /**
     * 現在ページの情報をクエリパラメータ化する
     *
     * @returns 遷移先に渡すクエリオブジェクト
     */
    const generateQuery = function (): CurrentPageQuery {
      // 現在のパス情報を取得
      const query: CurrentPageQuery = {
        prevPath: router.currentRoute.path,
      }

      // クエリ情報は存在する場合のみ処理実施
      if (Object.keys(router.currentRoute.query).length > 0) {
        // クエリをJSON文字列化し、URIエンコードを行って返す
        query['prevParams'] = encodeURI(JSON.stringify(router.currentRoute.query))
      }

      return query
    }

    /**
     * クエリパラメータから遷移元画面の情報を復元する
     *
     * @returns 遷移元画面の情報 未指定の場合はnull
     */
    const restorePage = function (): PrevPage | null {
      if (!router.currentRoute.query.prevPath) {
        // 遷移元URLが指定されていない場合はnullを返す
        return null
      }

      // クエリの復元
      let query = null
      if (router.currentRoute.query.prevParams) {
        // クエリが存在する場合、URIエンコードを行い、JSONオブジェクト化して返す
        query = JSON.parse(decodeURI(router.currentRoute.query.prevParams as string))
      }

      // 遷移先情報を返す
      return {
        path: router.currentRoute.query.prevPath as string,
        query: query,
      }
    }

    Vue.prototype.$prevPage = { generateQuery, restorePage }
  },
}

// ページ情報を保持するクエリ指定用オブジェクト
type CurrentPageQuery = {
  // 遷移元画面のパス(遷移先からはこのページへ戻る)
  prevPath: string
  // 遷移元画面のクエリ情報
  prevParams?: string
}

// 遷移元画面の情報を返すオブジェクト
type PrevPage = {
  // 戻り先のパス
  path: string
  // 戻り先に渡すクエリ
  query: any
}

/**
 * this.$prevPathで呼び出せるようインターフェース定義
 */
declare module 'vue/types/vue' {
  interface Vue {
    $prevPage: {
      /**
       * 現在ページの情報をクエリパラメータ化して返す
       *
       * @returns 遷移先に渡すクエリオブジェクト
       */
      generateQuery: () => CurrentPageQuery
      /**
       * クエリパラメータから遷移元画面の情報を復元する
       *
       * @returns 遷移元画面の情報 未指定の場合はnull
       */
      restorePage: () => PrevPage | null
    }
  }
}
